import { AxiosError } from "axios";
import { handleApiError } from "./instanceApi";
import { moodleInstanceApi } from "./moodleInstanceApi";

export const getAllMoodleQuiz = async (params: any) => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "mod_quiz_get_quizzes_by_courses",
          "courseids[0]": params,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const viewAssign = async (id: any) => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "mod_assign_view_assign",
          assignid: id,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const getMoodleQuizAttempsOverviews = async (quizId: any) => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "mod_quiz_get_user_attempts",
          quizid: quizId,
          status: "all",
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const startMoodleQuizAttempt = async (quizId: any) => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "mod_quiz_start_attempt",
          quizid: quizId,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const getMoodleQuizDetails = async (params: any) => {
  const { attemptid, page } = params;
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "mod_quiz_get_attempt_data",
          attemptid: attemptid,
          page: page || 0,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const submitQuizAnswer = async (params: any) => {
  const { attemptId, name, value, sequencecheck, sequencecheckValue } = params;
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "mod_quiz_process_attempt",
          attemptid: attemptId,
          "data[0][name]": name,
          "data[0][value]": value,
          "data[1][name]": sequencecheck,
          "data[1][value]": sequencecheckValue,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const saveQuizAnswer = async (params: any) => {
  const { attemptId, name, value, sequencecheck, sequencecheckValue } = params;
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "mod_quiz_save_attempt",
          attemptid: attemptId,
          "data[0][name]": name,
          "data[0][value]": value,
          "data[1][name]": sequencecheck,
          "data[1][value]": sequencecheckValue,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const finishQuizQuestion = async (params: any) => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "local_quiz_submit_finish_attempt",
          attemptid: params,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const getMoodleQuizReview = async (params: any) => {
  const { attemptid, page } = params;
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "mod_quiz_get_attempt_review",
          attemptid: attemptid,
          page: page || 0,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const getAllMoodleAssign = async (params: any) => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "mod_assign_get_assignments",
          "courseids[0]": params,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const getStatusSubmissions = async (assignId: any) => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "mod_assign_get_submission_status",
          assignid: assignId,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const saveAssignSubmission = async (params: any) => {
  const {
    assignId,
    onlinetextContent,
    onlinetextFormat,
    onlinetextItemid,
    fileUploadId,
  } = params;

  const bodyParams = new URLSearchParams({
    wsfunction: "mod_assign_save_submission",
    assignmentid: assignId,
    "plugindata[onlinetext_editor][text]": onlinetextContent,
    "plugindata[onlinetext_editor][format]": onlinetextFormat,
    "plugindata[onlinetext_editor][itemid]": onlinetextItemid,
    // "plugindata[files_filemanager]": onlinetextItemid,
  });

  // 👉 CHỈ THÊM files_filemanager KHI CÓ fileUploadId
  if (fileUploadId && Number(fileUploadId) > 0) {
    bodyParams.append("plugindata[files_filemanager]", String(fileUploadId));
  }

  try {
    const response = await moodleInstanceApi.post(
      "/webservice/rest/server.php",
      bodyParams
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const getAssignInfo = async (cmid: any) => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "local_assign_info_get_assignment",
          cmid: cmid,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const uploadAssign = async (params: any) => {
  const { contextid, component, filearea, itemid, filepath, filename, file } =
    params;

  try {
    // ✅ Lấy token
    const token = sessionStorage.getItem("wstoken");
    if (!token) {
      throw new Error("Missing Moodle API Token");
    }

    const formData = new FormData();
    formData.append("token", token);
    formData.append("filepath", filepath);
    formData.append("filename", filename);
    formData.append("contextid", contextid);
    formData.append("component", component);
    formData.append("filearea", filearea);
    formData.append("itemid", itemid);
    formData.append("file", file);

    const response = await moodleInstanceApi.post(
      `/webservice/upload.php?moodlewsrestformat=json`,
      formData
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const creatSubmission = async (assignId: any) => {
  try {
    const response = await moodleInstanceApi.get(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "local_init_submission_execute",
          assignid: assignId,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};
